/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.geofences.internal

import features.geofences.models.GeofencesModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class GeofencesServiceImpl : GeofencesService {

    private val geofencesRequest = GeofencesRequest()

    override suspend fun getBusinessGeofences(
        overrideHeaders : Map<String, String>?,
        pageNumber: Int,
        perPage: Int    ): Result<GeofencesModel> {
        return geofencesRequest.getBusinessGeofences(
            overrideHeaders = overrideHeaders,
            pageNumber = pageNumber,
            perPage = perPage        ).toModel()
    }
}
